import styled from 'styled-components';

function PegaTamanhoDaImagemLargura(){
    let elemento = document.getElementById('divimage');

    if (elemento){
    let largura = elemento.clientWidth;
        return largura+'px';
    }
    return 'inherit';
}

export const Post = styled.div`
    width:100%;
    display:flex;
    height:calc(100vh - 150px);
    padding:20px;
    @media(max-width:800px){
        display:flex;
        flex-wrap:wrap;
        flex:1;
        width: 100%;
        height: calc(100vh - 100px);
        overflow:hidden auto;
    }


`
export const DivBtn = styled.div`
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    justify-content:space-evenly;
    width:50%;
    @media(max-width:790px){
        width:100%;
    }
    @media(max-width:600px){
       > button:nth-child(2){
            display:none;
        }
    }
`
export const Button = styled.button`
    border:1px solid #333333;
    background-color:#333333;
    border-radius:5px;
    padding:5px;
    cursor:pointer;
    width:175px;
    :active {
        box-shadow: inset 0 0 2px rgba(128, 128, 128, 0.1);
        transform: translateY(2px);
    }

    @media(max-width:800px){
        width:150px;
        height:40px;
    }

`
export const DivButton = styled.div`
    border:1px solid #333333;
    background-color:#333333;
    border-radius:5px;
    padding:5px;
    cursor:pointer;
    width:175px;
    :active {
        box-shadow: inset 0 0 2px rgba(128, 128, 128, 0.1);
        transform: translateY(2px);
    }

    @media(max-width:800px){
        width:150px;
        height:40px;
    }

`

export const SpanButton = styled.span`

    font-size:16pt;
    font-family:Ubuntu;
    margin:0 5px;
    color:#fff;
    @media(max-width:800px){
        font-size:15px;
    }
`

export const DivConteudo = styled.div`
    display:flex;
    flex-wrap:wrap;
    flex-direction:row;
    justify-content:center;
    justify-items:center;
    width:auto;
    height: calc(100vh - 150px);
    overflow:hidden;
    justify-content: space-evenly;
    @media(max-width:790px){
        height:initial;
    }
`
export const DivPaiImagePostLiberado = styled.div`
 text-align:center;
 width:100%;
 height:100%;
 display:flex;
 flex-direction:column;

 @media(max-width:790px){
     width:100%;
 }
`
export const DivPaiImage = styled.div`
    width:50%;
     display:flex;
    flex-direction:column;
    @media(max-width:800px){
        width:100%;
    }
`
export const ImgBloqueada = styled.img`
    /* width:100%; */
    max-height:100%;
    max-width:100%;
    width:fit-content;
    height:fit-content;
    @media(max-width:800px){
        height:100%;
    }

`


export const DivImg = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    background-color:#fff;
    border-radius:5px;
    padding:10px;
    /* min-width:300px; */
    height:100%;
    user-select:none;
    text-align:center;
    width:100%;
    /* height:calc(100% - 60px); */

    @media(max-width:790){
        width:100%;
    }

`
export const DivImgLiberado = styled.div`
    transition-duration:.3s;
    width:100%;
    height:100%;

    :hover{
        >img{
            transition-duration:.3s;
            opacity:0.5;
        }
        label:nth-child(2){
            transition-duration:.3s;
            display:flow-root;
        }
    }

    >img{
        :hover{

        }
    }
    label:nth-child(2){
        cursor:pointer;
        display:none;

    }

    @media(max-width:800px){
        min-height:40px;
    }
`

export const ImgLiberado = styled.img`
    max-width:95%;
    height:calc(100% - 40px);
    margin:20px;
    :hover{

    }
    @media(max-width:800px){
        margin:0;
        max-width:100%;
        height:unset;
    }

`
export const LabelImageEditPost = styled.label`
`

export const TituloPost = styled.h1`
    font-size:20pt;
    font-family:'Ubuntu',Arial, Helvetica, sans-serif;
    margin:20px 0;
    background:#fff;
    width:100%;
    min-width:300px;
    border-radius:5px;
    padding: 10px 20px;
    resize:none;
    height: 70px;
    /* height:70%; */

    @media(max-width: 900px){
        font-size:26pt;
    }
`
export const InputTituloPost = styled.textarea`
    width:100%;
    height:80px;
    min-width:300px;
    font-size: 20pt;
    font-family: Ubuntu;
    font-weight: 600;
    border: 0;
    padding: 10px 20px;
    background:#fff;
    border-radius:5px;
    resize:none;
    overflow: hidden auto;
    margin: 20px 0;
    :focus{
        border:1px solid rgba(61, 126, 154, 0.8);
        -webkit-box-shadow: 10px 10px 43px -2px rgba(0,0,0,0.27);
        -moz-box-shadow: 10px 10px 43px -2px rgba(0,0,0,0.27);
        box-shadow: 10px 10px 43px -2px rgba(0,0,0,0.27);
    }
    @media(max-width:800px){
        height:120px;
        flex:1;
        font-size:20px;
        line-height:25px;
        vertical-align:middle;
    }
`


export const DivTextPost = styled.div`
    height:calc(100% - 150px);
    width:100%;
    font-weight:600;
    line-height:24px;
    user-select:none;
    font-family:Ubuntu;
    font-size:16px;
    /* overflow:hidden auto; */
    padding:5px 0 5px 10px;
    background-color:#fff;
    border-radius:5px;
    /* height: 70%; */
    overflow:hidden;
    @media(max-width:790px){
        height: calc(100vh - 375px);
    }

`
export const TextAreaTextPost = styled.textarea`
    width:100%;
    min-width:285px;
    height:calc(100% - 10px);
    font-weight:600;
    font-size:16px;
    font-family:Ubuntu;
    line-height:24px;
    user-select:none;
    overflow:hidden auto;
    padding: 25px;
    background-color:#fff;
    border-radius:5px;
    border:0px solid #fff;
    resize:none;
    :focus{
        border:1px solid rgba(61, 126, 154, 0.8);
        -webkit-box-shadow: 10px 10px 43px -2px rgba(0,0,0,0.27);
        -moz-box-shadow: 10px 10px 43px -2px rgba(0,0,0,0.27);
        box-shadow: 10px 10px 43px -2px rgba(0,0,0,0.27);
    }
    @media(max-width:790px){
        height:100%;
    }

`

export const P = styled.p`
    font-size:14pt;
    font-family:Ubuntu;
    text-align:center;
    margin-bottom:15px;
`

export const Divoption = styled.div`
    text-align:center;
`

export const Option = styled.button`
    display: inline-block;
    padding: 0.25em 0.5em;
    text-decoration: none;
    color: #ffffff;
    font-weight: bold;
    font-size:14pt;
    font-family:Ubuntu;
    border:1px solid #333333;
    background-color:#333333;
    border-style: solid;
    margin: auto 20px;
    border-radius:4px;
    :hover{
        cursor:pointer;
    }
    :active {
        box-shadow: inset 0 0 2px rgba(128, 128, 128, 0.1);
        transform: translateY(2px);
    }
`
export const DivPaiTituloETexto = styled.div`
    width:60%;
    padding: 10px;
    @media(max-width:790px){
        width:100%
    }
`
export const DivTextoBloqueado = styled.div`
    white-space:break-spaces;
    padding:inherit;
    overflow:auto;
    height:-webkit-fill-available;
    @media(max-width:790px){
        height:100%;
        padding-bottom:20px;
    }
`
